import { getAngle } from '@blade/common/components/paint/src/utils/polygon';
const parser = (val) => Math.round(val);
export const getRandomId = () => {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
export function hex2rgba(hexColor, opacity) {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const result = `rgba(${r}, ${g}, ${b}, ${opacity})`;
    return result;
}
export function drawRect(ctx, rect, DrawRectangleOption) {
    const { lineColor, fillColor, weight, opacity, dashed, dashedConfig } = DrawRectangleOption;
    ctx.beginPath();
    // 虚线设置
    if (dashed) {
        const _dashedConfig = dashedConfig && dashedConfig.length ? dashedConfig : [5, 5, 5];
        ctx.setLineDash(_dashedConfig);
    }
    else {
        ctx.setLineDash([]);
    }
    ctx.lineWidth = weight;
    ctx.strokeStyle = hex2rgba(lineColor, opacity);
    if (fillColor) {
        ctx.fillStyle = hex2rgba(fillColor, opacity);
    }
    const [{ x: startX, y: startY }, { x: endX, y: endY }] = rect;
    const width = endX - startX;
    const height = endY - startY;
    ctx.rect(startX, startY, width, height);
    fillColor && ctx.fill();
    ctx.stroke();
    return rect;
}
export function drawRoundRect(ctx, roundRect, options) {
    // start 为左上角第一个顶点坐标
    const { start, width, height, radius } = roundRect;
    const { x, y } = start;
    ctx.beginPath();
    ctx.moveTo(x, y);
    // 上边线
    ctx.lineTo(x + width, y);
    // 右上圆角
    ctx.arcTo(x + width + radius, y, x + width + radius, y + radius, radius);
    // 右边线
    ctx.lineTo(x + width + radius, y + height + radius);
    // 右下圆角
    ctx.arcTo(x + width + radius, y + height + 2 * radius, x + width, y + height + 2 * radius, radius);
    // 下边线
    ctx.lineTo(x, y + height + 2 * radius);
    // 左下圆角
    ctx.arcTo(x - radius, y + height + 2 * radius, x + -radius, y + height + radius, radius);
    // 左边线
    ctx.lineTo(x - radius, y + radius);
    // 左上圆角
    ctx.arcTo(x - radius, y, x, y, radius);
    ctx.lineTo(x, y);
    ctx.closePath();
    ctx.fillStyle = options.fillColor;
    ctx.lineWidth = options.weight;
    ctx.strokeStyle = options.lineColor;
    ctx.stroke();
    ctx.fill();
}
export const fittingText = (ctx, str, maxWidth) => {
    let width = ctx.measureText(str).width;
    const ellipsis = '…';
    const ellipsisWidth = ctx.measureText(ellipsis).width;
    if (width <= maxWidth || width <= ellipsisWidth) {
        return str;
    }
    else {
        const len = str.length;
        while (width >= maxWidth - ellipsisWidth && len > 0) {
            str = str.substring(0, len);
            width = ctx.measureText(str).width;
        }
        return str + ellipsis;
    }
};
export const drawPolygon = (ctx, vertexes, drawPolyOption) => {
    ctx.save();
    const { lineColor, fillColor, weight, scale } = drawPolyOption;
    ctx.fillStyle = fillColor;
    ctx.lineWidth = weight;
    ctx.strokeStyle = lineColor;
    ctx.beginPath();
    ctx.moveTo(parser(vertexes[0].x * scale), parser(vertexes[0].y * scale));
    // ctx.fillText(`${vertexes[0].x} ${vertexes[0].y}`, Number(vertexes[0].x)+5, Number(vertexes[0].y)+5);
    for (let i = 1; i < vertexes.length; i++) {
        const { x, y } = vertexes[i];
        ctx.lineTo(parser(x * scale), parser(y * scale));
        // ctx.save();
        // ctx.fillStyle='red';
        // ctx.fillText(`${vertexes[i].x} ${vertexes[i].y}`, Number(vertexes[i].x)-10, Number(vertexes[i].y)-10);
        // ctx.restore();
        // console.log("vertexes:",`${vertexes[i].x} ${vertexes[i].y}`)
    }
    ctx.stroke();
    ctx.closePath();
    ctx.fill();
    ctx.restore();
};
export const drawLines = (ctx, vertexes, drawPolyOption) => {
    ctx.save();
    const { lineColor, fillColor, weight, scale } = drawPolyOption;
    ctx.lineWidth = weight;
    ctx.strokeStyle = lineColor;
    ctx.beginPath();
    ctx.moveTo(parser(vertexes[0].x * scale), parser(vertexes[0].y * scale));
    // ctx.fillText(`${vertexes[0].x} ${vertexes[0].y}`, Number(vertexes[0].x)+5, Number(vertexes[0].y)+5);
    for (let i = 1; i < vertexes.length; i++) {
        const { x, y } = vertexes[i];
        ctx.lineTo(parser(x * scale), parser(y * scale));
        // ctx.save();
        // ctx.fillStyle='red';
        // ctx.fillText(`${vertexes[i].x} ${vertexes[i].y}`, Number(vertexes[i].x)-10, Number(vertexes[i].y)-10);
        // ctx.restore();
        // console.log("vertexes:",`${vertexes[i].x} ${vertexes[i].y}`)
    }
    ctx.stroke();
    ctx.closePath();
    ctx.restore();
};
export const drawArrow = (ctx, fromX, fromY, toX, toY, color) => {
    const headlen = 10;
    const theta = 45;
    let arrowX, arrowY;
    // 计算各角度和对应的箭头终点坐标
    const angle = (Math.atan2(fromY - toY, fromX - toX) * 180) / Math.PI;
    const angle1 = ((angle + theta) * Math.PI) / 180;
    const angle2 = ((angle - theta) * Math.PI) / 180;
    const topX = headlen * Math.cos(angle1);
    const topY = headlen * Math.sin(angle1);
    const botX = headlen * Math.cos(angle2);
    const botY = headlen * Math.sin(angle2);
    ctx.beginPath();
    ctx.lineWidth = 5;
    // 画直线
    ctx.moveTo(fromX, fromY);
    ctx.lineTo(toX, toY);
    arrowX = toX + topX;
    arrowY = toY + topY;
    // 画上边箭头线
    ctx.moveTo(arrowX, arrowY);
    ctx.lineTo(toX, toY);
    arrowX = toX + botX;
    arrowY = toY + botY;
    // 画下边箭头线
    ctx.lineTo(arrowX, arrowY);
    ctx.strokeStyle = color;
    ctx.stroke();
};
export const drawLine = (ctx, fromX, fromY, toX, toY, color) => {
    ctx.save();
    ctx.beginPath();
    ctx.lineWidth = 5;
    ctx.strokeStyle = 'red';
    // 画直线
    ctx.moveTo(fromX, fromY);
    ctx.lineTo(toX, toY);
    ctx.strokeStyle = color;
    ctx.stroke();
    ctx.restore();
};
export const drawDirArrow = (ctx, vertices, scale) => {
    ctx.save();
    const { start, end } = vertices;
    const mid = { x: start.x + (end.x - start.x) / 2, y: start.y + (end.y - start.y) / 2 };
    const [vStart, vEnd] = getVertical(start, mid, 60);
    const vMid = { x: vStart.x + (vEnd.x - vStart.x) / 2, y: vStart.y + (vEnd.y - vStart.y) / 2 };
    const arrowVertex = getVertexInLine(vEnd, vStart, 15);
    const [left, right] = getVertical(vStart, arrowVertex, 6);
    ctx.fillStyle = '#F7B500';
    ctx.strokeStyle = '#F7B500';
    ctx.globalAlpha = 1;
    ctx.lineWidth = 2;
    ctx.moveTo(left.x, left.y);
    ctx.lineTo(right.x, right.y);
    ctx.lineTo(vEnd.x, vEnd.y);
    ctx.fill();
    const arrowMid = { x: left.x + (right.x - left.x) / 2, y: left.y + (right.y - left.y) / 2 };
    const arrowTail = getVertexInLine(arrowMid, vMid, 30);
    drawLine(ctx, arrowTail.x, arrowTail.y, arrowMid.x, arrowMid.y, '#F7B500');
    ctx.restore();
};
export function getVertexInLine(a, b, length = 15) {
    if (a.x === b.x)
        return { x: a.x, y: a.y + length };
    if (a.y === b.y)
        return { x: a.x + length, y: a.y };
    const angle = getAngle(a, b);
    const ar = Math.PI * (angle / 180);
    const x = Math.round(length * Math.cos(ar) + a.x);
    const y = Math.round(length * Math.sin(ar) + a.y);
    return { x, y };
}
export function getVertical(a, b, distance = 15) {
    const angle = getAngle(a, b); // 两点角度
    const dAngle = angle - 90; // 垂线的角度
    const dr = Math.PI * (dAngle / 180); // 垂线弧度
    const line = distance || 15;
    const sx = Math.round(line * Math.cos(dr));
    const sy = Math.round(line * Math.sin(dr));
    const a1 = { x: b.x + sx, y: b.y + sy };
    const b1 = { x: b.x - sx, y: b.y - sy };
    return [a1, b1];
}
